module.exports = __webpack_public_path__ + "static/img/reason_head_3.382b94da.png";